import React from 'react';
export function LifestyleGallery() {
  const images = [{
    url: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800&q=80',
    alt: 'Leaders collaborating on AI strategy by the beach',
    caption: 'Beachside Strategy Sessions'
  }, {
    url: 'https://images.unsplash.com/photo-1511578314322-379afb476865?w=800&q=80',
    alt: 'Group of executives networking at sunset',
    caption: 'Evening Networking'
  }, {
    url: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=800&q=80',
    alt: 'Team working together on laptops in modern space',
    caption: 'Hands-On Prototyping Labs'
  }, {
    url: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80',
    alt: 'Diverse group of professionals in discussion',
    caption: 'Peer Learning & Collaboration'
  }, {
    url: 'https://images.unsplash.com/photo-1540541338287-41700207dee6?w=800&q=80',
    alt: 'Ocean view from resort balcony',
    caption: 'Cancun Ocean Views'
  }, {
    url: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800&q=80',
    alt: 'Group celebrating success together',
    caption: 'Celebrating Breakthroughs'
  }];
  return <section className="py-24" data-id="element-281">
      <div className="max-w-7xl mx-auto px-6" data-id="element-282">
        <div className="text-center mb-16" data-id="element-283">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-284">
            Work Hard. Play Hard. Transform.
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-285">
            Experience the perfect blend of intensive learning and beachside
            rejuvenation in Cancun
          </p>
        </div>

        {/* Image grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-286">
          {images.map((image, index) => <div key={index} className="group relative aspect-[4/3] rounded-2xl overflow-hidden border border-slate-800 hover:border-cyan-500/50 transition-all duration-300" data-id="element-287">
              <img src={image.url} alt={image.alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-288" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/50 to-transparent opacity-80" data-id="element-289"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-290">
                <p className="text-white font-semibold text-lg" data-id="element-291">
                  {image.caption}
                </p>
              </div>
            </div>)}
        </div>

        {/* Experience highlights */}
        <div className="grid md:grid-cols-4 gap-8 text-center" data-id="element-292">
          <div className="bg-slate-800/30 border border-slate-700/50 rounded-xl p-6" data-id="element-293">
            <div className="text-3xl mb-2" data-id="element-294">🌅</div>
            <h3 className="text-lg font-semibold text-white mb-2" data-id="element-295">
              Sunrise Sessions
            </h3>
            <p className="text-sm text-slate-400" data-id="element-296">
              Start each day with clarity and focus
            </p>
          </div>
          <div className="bg-slate-800/30 border border-slate-700/50 rounded-xl p-6" data-id="element-297">
            <div className="text-3xl mb-2" data-id="element-298">🏖️</div>
            <h3 className="text-lg font-semibold text-white mb-2" data-id="element-299">
              Beach Breaks
            </h3>
            <p className="text-sm text-slate-400" data-id="element-300">
              Recharge between intensive sessions
            </p>
          </div>
          <div className="bg-slate-800/30 border border-slate-700/50 rounded-xl p-6" data-id="element-301">
            <div className="text-3xl mb-2" data-id="element-302">🎵</div>
            <h3 className="text-lg font-semibold text-white mb-2" data-id="element-303">
              Evening Events
            </h3>
            <p className="text-sm text-slate-400" data-id="element-304">
              Live music and networking by the ocean
            </p>
          </div>
          <div className="bg-slate-800/30 border border-slate-700/50 rounded-xl p-6" data-id="element-305">
            <div className="text-3xl mb-2" data-id="element-306">🤝</div>
            <h3 className="text-lg font-semibold text-white mb-2" data-id="element-307">
              Lifelong Connections
            </h3>
            <p className="text-sm text-slate-400" data-id="element-308">
              Build relationships that last beyond Cancun
            </p>
          </div>
        </div>

        {/* Quote */}
        <div className="mt-16 text-center" data-id="element-309">
          <blockquote className="text-2xl text-slate-300 italic max-w-3xl mx-auto" data-id="element-310">
            "The Cancun setting wasn't just nice—it was strategic. Morning
            sessions were intense, afternoon recharge by the ocean, evening
            collaboration. I learned more in 48 hours than 6 months of
            webinars."
          </blockquote>
          <p className="text-slate-500 mt-4" data-id="element-311">
            — Lisa Thompson, Chief Innovation Officer
          </p>
        </div>
      </div>
    </section>;
}